export const GET_CASH_PAYMENT_TRANSACTIONS = 'GET_CASH_PAYMENT_TRANSACTIONS';
export const CASH_PAYMENT_TRANSACTION_REQUEST = 'CASH_PAYMENT_TRANSACTION_REQUEST';
export const CASH_PAYMENT_TRANSACTION_REQUEST_FAILURE = 'CASH_PAYMENT_TRANSACTION_REQUEST_FAILURE';